import React from 'react';
// Import the PNG logo once here
import mainLogo from '../images/NEWEST_H.png'; // adjust path to your actual folder
// A simple Logo component
export default function LogoHAL({ width = 50, height, style }) {
  return (
    <img
      src={mainLogo}
      alt="Site Logo"
      style={{
        width: width,
        height: height, // or auto if not provided
        ...style
      }}
    />
  );
}
